import { random, upperFirst } from 'lodash';

export function mapArrayToObj(items) {
  const result = {};

  items.forEach((item) => {
    result[item.id] = item;
  });

  return result;
}

export function generateWarriorName(gender = 'male') {
  const nm1 = [
    'ae',
    'au',
    'ei',
    'a',
    'e',
    'i',
    'o',
    'u',
    'a',
    'e',
    'i',
    'o',
    'u',
    'a',
    'e',
    'i',
    'o',
    'u',
  ];
  const nm2 = [
    '',
    '',
    '',
    'b',
    'bl',
    'br',
    'bh',
    'd',
    'dr',
    'dh',
    'f',
    'fr',
    'g',
    'gh',
    'gr',
    'gl',
    'h',
    'hy',
    'hr',
    'j',
    'k',
    'kh',
    'kr',
    'l',
    'll',
    'm',
    'n',
    'p',
    'pr',
    'r',
    'rh',
    's',
    'sk',
    'sg',
    'sm',
    'sn',
    'st',
    't',
    'th',
    'thr',
    'ty',
    'v',
    'y',
  ];
  const nm3 = [
    'bl',
    'br',
    'd',
    'db',
    'dbr',
    'dd',
    'ddg',
    'dg',
    'dl',
    'dm',
    'dr',
    'dv',
    'f',
    'fd',
    'fgr',
    'fk',
    'fl',
    'fn',
    'fr',
    'fst',
    'fv',
    'g',
    'gb',
    'gd',
    'gf',
    'gg',
    'ggv',
    'gl',
    'gn',
    'gr',
    'gss',
    'gv',
    'k',
    'kk',
    'l',
    'lb',
    'lc',
    'ld',
    'ldr',
    'lf',
    'lfr',
    'lg',
    'lgr',
    'lk',
    'll',
    'llg',
    'llk',
    'llv',
    'lm',
    'ln',
    'lp',
    'lr',
    'ls',
    'lsk',
    'lsn',
    'lst',
    'lsv',
    'lt',
    'lv',
    'm',
    'md',
    'mk',
    'ml',
    'mm',
    'ms',
    'n',
    'nb',
    'nd',
    'ndr',
    'ng',
    'nl',
    'nn',
    'nng',
    'nr',
    'nsk',
    'nt',
    'nv',
    'nw',
    'p',
    'pl',
    'pp',
    'pr',
    'r',
    'rb',
    'rd',
    'rdg',
    'rf',
    'rg',
    'rgr',
    'rk',
    'rkm',
    'rl',
    'rls',
    'rm',
    'rn',
    'rng',
    'rngr',
    'rnh',
    'rnk',
    'rns',
    'rnv',
    'rr',
    'rst',
    'rt',
    'rth',
    'rtm',
    'rv',
    's',
    'sb',
    'sbr',
    'sg',
    'sgr',
    'sk',
    'sl',
    'sm',
    'sn',
    'sr',
    'ssk',
    'st',
    'stm',
    'str',
    'sv',
    't',
    'tg',
    'th',
    'thg',
    'thn',
    'thr',
    'thv',
    'tm',
    'tr',
    'tt',
    'ttf',
    'tv',
    'v',
    'yv',
    'z',
    'zg',
    'zl',
    'zn',
  ];
  const nm4 = [
    'd',
    'dr',
    'f',
    'g',
    'kr',
    'k',
    'l',
    'ld',
    'lf',
    'lk',
    'll',
    'lr',
    'm',
    'mm',
    'n',
    'nd',
    'nn',
    'r',
    'rd',
    'rn',
    'rr',
    's',
    'th',
    't',
  ];
  const nm5 = [
    '',
    '',
    '',
    'b',
    'br',
    'bh',
    'ch',
    'd',
    'dh',
    'f',
    'fr',
    'g',
    'gh',
    'gr',
    'gw',
    'gl',
    'h',
    'j',
    'k',
    'kh',
    'm',
    'n',
    'r',
    'rh',
    's',
    'sh',
    'st',
    'sv',
    't',
    'th',
    'thr',
    'tr',
    'v',
    'w',
  ];
  const nm6 = [
    'ae',
    'ea',
    'ie',
    'ei',
    'io',
    'a',
    'e',
    'i',
    'o',
    'u',
    'a',
    'e',
    'i',
    'o',
    'u',
    'a',
    'e',
    'i',
    'o',
    'u',
    'a',
    'e',
    'i',
    'o',
    'u',
    'a',
    'e',
    'i',
    'o',
    'u',
  ];
  const nm7 = [
    'bj',
    'c',
    'd',
    'dd',
    'df',
    'dl',
    'dr',
    'f',
    'ff',
    'fl',
    'fn',
    'fr',
    'fth',
    'g',
    'gd',
    'gm',
    'gn',
    'gnh',
    'gr',
    'h',
    'hh',
    'k',
    'l',
    'ld',
    'lf',
    'lfh',
    'lg',
    'lgr',
    'lh',
    'lk',
    'll',
    'lm',
    'lr',
    'ls',
    'lv',
    'm',
    'mm',
    'n',
    'nd',
    'ndr',
    'ng',
    'ngr',
    'ngv',
    'nh',
    'nl',
    'nn',
    'nnh',
    'nr',
    'ns',
    'nt',
    'nv',
    'r',
    'rd',
    'rf',
    'rg',
    'rgh',
    'rgr',
    'rh',
    'rk',
    'rl',
    'rm',
    'rn',
    'rnd',
    'rng',
    'rr',
    'rst',
    'rt',
    'rth',
    'rtr',
    'rv',
    's',
    'sb',
    'sd',
    'sg',
    'sh',
    'sl',
    'st',
    'stn',
    'str',
    'sv',
    't',
    'thr',
    'tk',
    'tr',
    'tt',
    'tth',
    'v',
    'y',
    'yj',
    'ym',
    'yn',
  ];
  const nm8 = ['', '', '', '', 'f', 'g', 'h', 'l', 'n', 'nn', 's', 'sh', 'th', 'y'];

  const i = random(0, 9);

  let rnd;
  let rnd2;
  let rnd3;
  let rnd4;
  let rnd5;
  let rnd6;
  let rnd7;
  let names;
  if (gender === 'female') {
    rnd = Math.floor(Math.random() * nm5.length);
    rnd2 = Math.floor(Math.random() * nm6.length);
    rnd3 = Math.floor(Math.random() * nm8.length);
    if (i < 3) {
      while (rnd < 5) {
        rnd = Math.floor(Math.random() * nm5.length);
      }
      names = nm5[rnd] + nm6[rnd2] + nm8[rnd3];
    } else if (i < 8) {
      rnd4 = Math.floor(Math.random() * nm6.length);
      if (rnd2 < 5) {
        while (rnd4 < 5) {
          rnd4 = Math.floor(Math.random() * nm6.length);
        }
      }
      rnd5 = Math.floor(Math.random() * nm7.length);
      names = nm5[rnd] + nm6[rnd2] + nm7[rnd5] + nm6[rnd4] + nm8[rnd3];
    } else {
      rnd4 = Math.floor(Math.random() * nm6.length);
      if (rnd2 < 5) {
        while (rnd4 < 5) {
          rnd4 = Math.floor(Math.random() * nm6.length);
        }
      }
      rnd5 = Math.floor(Math.random() * nm7.length);
      rnd6 = Math.floor(Math.random() * nm6.length);
      if (rnd2 < 5 || rnd4 < 5) {
        while (rnd6 < 5) {
          rnd6 = Math.floor(Math.random() * nm6.length);
        }
      }
      rnd7 = Math.floor(Math.random() * nm7.length);
      names = nm5[rnd] + nm6[rnd2] + nm7[rnd5] + nm6[rnd4] + nm7[rnd7] + nm6[rnd6];
    }
  } else {
    rnd = Math.floor(Math.random() * nm2.length);
    rnd2 = Math.floor(Math.random() * nm1.length);
    rnd3 = Math.floor(Math.random() * nm4.length);
    if (i < 3) {
      names = nm2[rnd] + nm1[rnd2] + nm4[rnd3];
    } else if (i < 8) {
      rnd4 = Math.floor(Math.random() * nm1.length);
      if (rnd < 3) {
        while (rnd4 < 3) {
          rnd4 = Math.floor(Math.random() * nm1.length);
        }
      }
      rnd5 = Math.floor(Math.random() * nm3.length);
      names = nm2[rnd] + nm1[rnd2] + nm3[rnd5] + nm1[rnd4] + nm4[rnd3];
    } else {
      rnd4 = Math.floor(Math.random() * nm1.length);
      if (rnd < 3) {
        while (rnd4 < 3) {
          rnd4 = Math.floor(Math.random() * nm1.length);
        }
      }
      rnd5 = Math.floor(Math.random() * nm3.length);
      rnd6 = Math.floor(Math.random() * nm1.length);
      if (rnd < 3 || rnd4 < 3) {
        while (rnd6 < 3) {
          rnd6 = Math.floor(Math.random() * nm1.length);
        }
      }
      rnd7 = Math.floor(Math.random() * nm3.length);
      names = nm2[rnd] + nm1[rnd2] + nm3[rnd5] + nm1[rnd4] + nm3[rnd7] + nm1[rnd6] + nm4[rnd3];
    }
  }

  return upperFirst(names);
}

export function generateThingName() {
  const names1 = [
    'Alien',
    'Ancestor',
    'Arcane',
    'Assassin',
    'Battle',
    'Birthright',
    'Blood',
    'Bloodline',
    'Brave',
    'Broken',
    'Castle',
    'Chaos',
    'Chosen',
    'Clone',
    'Covert',
    'Creature',
    'Crystal',
    'Dark',
    'Dawn',
    'Death',
    'Demon',
    'Divine',
    'Dragon',
    'Dungeon',
    'Endless',
    'Epic',
    'Eternal',
    'Exiled',
    'Fallen',
    'Fantasy',
    'Forbidden',
    'Forsaken',
    'Freedom',
    'Full Moon',
    'Ghost',
    'Golden',
    'Gothic',
    'Grand',
    'Grim',
    'Holy',
    'Honest',
    'Immortal',
    'Incredible',
    'Infernal',
    'Infinite',
    'Iron',
    'Kingdom',
    'Knight',
    'Knightmare',
    'Last',
    'Lifeless',
    'Lightning',
    'Lost',
    'Love',
    'Mage',
    'Magic',
    'Majestic',
    'Master',
    'Metal',
    'Monster',
    'Moonlight',
    'Morbid',
    'Mortal',
    'Mutant',
    'Mystic',
    'Nether',
    'Night',
    'Obsidian',
    'Paradise',
    'Phantom',
    'Pioneer',
    'Pirate',
    'Plague',
    'Planetary',
    'Raiding',
    'Rainbow',
    'Reborn',
    'Royal',
    'Rune',
    'Sacred',
    'Scarlet',
    'Shadow',
    'Shapeshifter',
    'Shattered',
    'Simple',
    'Soul',
    'Space',
    'Spellborn',
    'Star',
    'Stolen',
    'Storm',
    'Sunset',
    'Tempest',
    'Thunder',
    'Ultimate',
    'Undead',
    'Undercover',
    'Underworld',
    'Vampire',
    'Werewolf',
  ];
  const names2 = [
    'Adventure',
    'Age',
    'Awakening',
    'Blade',
    'Blitz',
    'Brotherhood',
    'Call',
    'Challenge',
    'Champions',
    'Choice',
    'Chronicles',
    'Citizen',
    'City',
    'Clans',
    'Clash',
    'Colony',
    'Crusade',
    'Curse',
    'Dawn',
    'Defender',
    'Desciple',
    'Destiny',
    'Dimension',
    'Dominion',
    'Dungeon',
    'Empire',
    'Evolution',
    'Expedition',
    'Faction',
    'Fate',
    'Flames',
    'Force',
    'Gates',
    'Genesis',
    'God',
    'Guilds',
    'Harbinger',
    'Harvest',
    'Heaven',
    'Hell',
    'Hero',
    'Heroes',
    'History',
    'Hunter',
    'Inferno',
    'Invasion',
    'Isle',
    'King',
    'Labyrinth',
    'Lair',
    'Lands',
    'Legacy',
    'Legend',
    'Legends',
    'Legions',
    'Lord',
    'Might',
    'Mythos',
    'Nightmare',
    'Oath',
    'Odyssey',
    'Omen',
    'Origins',
    'Paradise',
    'Past',
    'Power',
    'Prince',
    'Prophecy',
    'Quest',
    'Reach',
    'Realm',
    'Reaper',
    'Reign',
    'Revelations',
    'Rise',
    'Rising',
    'Saga',
    'Sanctuary',
    'School',
    'Secrets',
    'Siege',
    'Skies',
    'Sorcery',
    'Soul',
    'Spyre',
    'Story',
    'Stronghold',
    'Surprise',
    'Tale',
    'Throne',
    'Time',
    'Treasure',
    'Tribes',
    'Universe',
    'Vaults',
    'War',
    'Ward',
    'Watch',
    'Wizards',
    'World',
  ];
  const names3 = [
    'Angels',
    'Barbarians',
    'Castles',
    'Codes',
    'Conquest',
    'Crowns',
    'Curses',
    'Demons',
    'Dragons',
    'Dreams',
    'Elves',
    'Ghosts',
    'Giants',
    'Goblins',
    'Illusions',
    'Kings',
    'Knights',
    'Legends',
    'Lords',
    'Love',
    'Magic',
    'Monsters',
    'Mysteries',
    'Nightmares',
    'Orcs',
    'Outlaws',
    'Phantoms',
    'Pirates',
    'Power',
    'Prophecies',
    'Realms',
    'Riddles',
    'Robots',
    'Sailors',
    'Secrets',
    'Shadows',
    'Shields',
    'Ships',
    'Sorcery',
    'Souls',
    'Spells',
    'Spirits',
    'Swords',
    'Traitors',
    'Treasures',
    'Vampires',
    'Vikings',
    'War',
    'Werewolves',
    'Wizards',
  ];
  const names4 = [
    'Betrayal',
    'Bravery',
    'Conjury',
    'Conquest',
    'Danger',
    'Darkness',
    'Death',
    'Deception',
    'Enigmas',
    'Exploration',
    'Fables',
    'Faith',
    'Fate',
    'Fortune',
    'Hauntings',
    'Heirlooms',
    'Heritage',
    'Honor',
    'Hope',
    'Horrors',
    'Justice',
    'Labyrinths',
    'Legacies',
    'Legends',
    'Lore',
    'Love',
    'Magic',
    'Memories',
    'Miracles',
    'Murder',
    'Mystery',
    'Mythology',
    'Mythos',
    'Myths',
    'Nightmares',
    'Oracles',
    'Origins',
    'Riddles',
    'Rituals',
    'Romance',
    'Runes',
    'Secrets',
    'Shadows',
    'Sins',
    'Sorrow',
    'Supremacy',
    'Time',
    'Triumph',
    'Victory',
    'Witchcraft',
  ];
  const names5 = [
    'Aeon',
    'Age',
    'Agent',
    'Angel',
    'Armies',
    'Ashes',
    'Aura',
    'Blade',
    'Book',
    'Burden',
    'Case',
    'Century',
    'Challenges',
    'Champions',
    'Children',
    'Chronicles',
    'Circle',
    'City',
    'Clans',
    'Core',
    'Corruption',
    'Creatures',
    'Crypt',
    'Cult',
    'Curse',
    'Dawn',
    'Death',
    'Demons',
    'Destiny',
    'Dimension',
    'Division',
    'Dominion',
    'Doom',
    'Dreams',
    'Dungeons',
    'Edge',
    'Empire',
    'Enemy',
    'Era',
    'Evil',
    'Fables',
    'Face',
    'Faith',
    'Fall',
    'Fate',
    'Fire',
    'Forest',
    'Game',
    'God',
    'Gods',
    'Guardians',
    'Guilds',
    'Heart',
    'Heroes',
    'Immortals',
    'Invasion',
    'Journey',
    'Kingdom',
    'Kings',
    'Knights',
    'Lair',
    'Land',
    'Legacy',
    'Legend',
    'Legends',
    'Lords',
    'Masters',
    'Monsters',
    'Mortals',
    'Mysteries',
    'Myths',
    'Oracles',
    'Origin',
    'Path',
    'Planet',
    'Quests',
    'Realm',
    'Revelations',
    'Rise',
    'Saga',
    'Saints',
    'School',
    'Search',
    'Secret',
    'Seed',
    'Shadows',
    'Souls',
    'Swords',
    'Tale',
    'Tales',
    'Throne',
    'Time',
    'Titans',
    'Tombs',
    'Tribes',
    'Voice',
    'Voices',
    'Whispers',
    'Winds',
    'World',
  ];
  const names6 = [
    'Alchemy',
    'Aliens',
    'Anarchy',
    'Ancestors',
    'Angels',
    'Autumn',
    'Blood',
    'Chaos',
    'Crimson',
    'Crisis',
    'Darkness',
    'Death',
    'Destruction',
    'Discovery',
    'Dominion',
    'Doom',
    'Dragons',
    'Dreams',
    'Dust',
    'Dystopia',
    'Earth',
    'Echoes',
    'Eden',
    'Elements',
    'Eternity',
    'Euphoria',
    'Evil',
    'Evolution',
    'Exiles',
    'Exploration',
    'Fate',
    'Fear',
    'Fire',
    'Fortune',
    'Fury',
    'Gods',
    'Gold',
    'Greed',
    'Grimoires',
    'Guilds',
    'Heaven',
    'History',
    'Honesty',
    'Honor',
    'Hope',
    'Infernals',
    'Infinity',
    'Iron',
    'Judgement',
    'Kings',
    'Knights',
    'Labyrinths',
    'Legions',
    'Light',
    'Lore',
    'Love',
    'Magic',
    'Malice',
    'Mankind',
    'Might',
    'Money',
    'Moonlight',
    'Mystery',
    'Necromancy',
    'New Earth',
    'Nightmares',
    'Power',
    'Prophecies',
    'Rage',
    'Realms',
    'Rebirth',
    'Reckoning',
    'Retribution',
    'Romance',
    'Ruins',
    'Runes',
    'Savagery',
    'Science',
    'Sin',
    'Sorcery',
    'Souls',
    'Spring',
    'Stars',
    'Steel',
    'Summer',
    'Thieves',
    'Thunder',
    'Time',
    'Trials',
    'Truth',
    'Twilight',
    'Undeath',
    'Utopia',
    'Valor',
    'Vampires',
    'Vengeance',
    'Virtue',
    'War',
    'Werewolves',
    'Winter',
  ];
  const names7 = [
    'Arcane',
    'Arche',
    'Astro',
    'Battle',
    'Bio',
    'Blood',
    'Brutal',
    'Castle',
    'Chrono',
    'Dark',
    'Dead',
    'Demon',
    'Dragon',
    'Dream',
    'Ember',
    'Ever',
    'Far',
    'Fire',
    'Ghost',
    'Grim',
    'Heaven',
    'Hell',
    'Hero',
    'Iron',
    'Knight',
    'Light',
    'Mage',
    'Magic',
    'Master',
    'Mortal',
    'Night',
    'Phantom',
    'Quest',
    'Raid',
    'Rune',
    'Sacred',
    'Scarlet',
    'Shadow',
    'Shard',
    'Siege',
    'Sky',
    'Soul',
    'Space',
    'Spell',
    'Star',
    'Storm',
    'Strong',
    'Thunder',
    'Trade',
    'War',
  ];
  const names8 = [
    'age',
    'band',
    'blade',
    'borne',
    'child',
    'craft',
    'crest',
    'cry',
    'doom',
    'fight',
    'fire',
    'flight',
    'force',
    'gate',
    'guard',
    'guild',
    'heart',
    'hunt',
    'kin',
    'land',
    'line',
    'mare',
    'master',
    'mind',
    'more',
    'night',
    'path',
    'phase',
    'realm',
    'reign',
    'rite',
    'run',
    'scape',
    'shift',
    'side',
    'slayer',
    'space',
    'sphere',
    'star',
    'stone',
    'storm',
    'tale',
    'tide',
    'time',
    'trail',
    'vale',
    'view',
    'ville',
    'watch',
    'way',
  ];
  const i = random(0, 9);
  let rnd;
  let rnd2;
  let names;
  if (i < 2) {
    rnd = Math.floor(Math.random() * names1.length);
    rnd2 = Math.floor(Math.random() * names2.length);
    names = `${names1[rnd]} ${names2[rnd2]}`;
  } else if (i < 4) {
    rnd = Math.floor(Math.random() * names3.length);
    rnd2 = Math.floor(Math.random() * names4.length);
    names = `${names3[rnd]} of ${names4[rnd2]}`;
  } else if (i < 5) {
    rnd = Math.floor(Math.random() * names5.length);
    rnd2 = Math.floor(Math.random() * names5.length);
    while (rnd2 === rnd) {
      rnd2 = Math.floor(Math.random() * names5.length);
    }
    names = `${names5[rnd]} and ${names5[rnd2]}`;
  } else if (i < 6) {
    rnd = Math.floor(Math.random() * names6.length);
    rnd2 = Math.floor(Math.random() * names6.length);
    while (rnd2 === rnd) {
      rnd2 = Math.floor(Math.random() * names6.length);
    }
    names = `${names6[rnd]} and ${names6[rnd2]}`;
  } else {
    rnd = Math.floor(Math.random() * names7.length);
    rnd2 = Math.floor(Math.random() * names8.length);
    names = names7[rnd] + names8[rnd2];
  }
  return names;
}
